import { router } from '@/router'

// Environment Variables
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID
const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID

let isInitialized = false

/**
 * Initialize analytics if consent is granted
 */
export function initAnalytics() {
  if (isInitialized) return

  const consent = localStorage.getItem('cookie_consent')
  if (consent === 'accepted') {
    loadScripts()
    startTracking()
    isInitialized = true
  }
}

/**
 * Set consent status
 * @param {'accepted' | 'declined'} status 
 */
export function setConsent(status) {
  localStorage.setItem('cookie_consent', status)
  if (status === 'accepted') {
    initAnalytics()
  }
}

/**
 * Check if consent banner should be shown
 */
export function shouldShowBanner() {
  return !localStorage.getItem('cookie_consent')
}

/**
 * Track a page view
 * @param {string} path 
 */
export function trackPageView(path) {
  if (!isInitialized) return

  // Google Analytics
  if (window.gtag && GA_MEASUREMENT_ID) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path
    })
  }

  // Clarity automatically tracks hash changes, so manual page view might be redundant 
  // but helpful for explicit state changes if needed.
}

/**
 * Track a custom event
 * @param {string} eventName 
 * @param {object} params 
 */
export function trackEvent(eventName, params = {}) {
  if (!isInitialized) return

  if (window.gtag && GA_MEASUREMENT_ID) {
    window.gtag('event', eventName, params)
  }
  
  if (window.clarity && CLARITY_PROJECT_ID) {
    window.clarity('event', eventName, params)
  }
}

// Internal Helper: Load Scripts
function loadScripts() {
  // 1. Google Analytics
  if (GA_MEASUREMENT_ID) {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
    document.head.appendChild(script)

    window.dataLayer = window.dataLayer || []
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag
    gtag('js', new Date())
    gtag('config', GA_MEASUREMENT_ID)
  }

  // 2. Microsoft Clarity
  if (CLARITY_PROJECT_ID) {
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
  }
}

// Internal Helper: Start Route Listener
function startTracking() {
  // Track initial page
  trackPageView(router.getPath())

  // Listen for route changes
  router.onChange((state) => {
    trackPageView(state.path)
  })
}
